import { render, staticRenderFns } from "./SRoundedIcon.vue?vue&type=template&id=b45fedfe&scoped=true&lang=pug"
import script from "./SRoundedIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SRoundedIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SRoundedIcon.vue?vue&type=style&index=0&id=b45fedfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45fedfe",
  null
  
)

export default component.exports